import axios from "axios";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "students-create",
  components: {},
  props: [],
  data() {
    return {
      user: {},
      groups: ["A", "B", "C", "D"],
      roles: [],
      teams: [],
      password2: "",
      show: true
    };
  },
  computed: {},
  beforeMount() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Backend" },
      { title: "Users", route: "students" },
      { title: "Create Student" }
    ]);
    axios.get("roles").then(response => {
      //console.log(response);
      this.roles = response.data;
    });
  },
  mounted() {},
  methods: {
    onSubmit() {
      if (this.user.password == this.password2) {
        axios.post("register/", this.user).then(response => {
          console.log(response.data);
        });
      }
      //evt.preventDefault();
      this.$router.push({ name: "students" });
    }
  }
};
